// extracted by mini-css-extract-plugin
module.exports = {"main-component":"refresh_main-component__2IYn3"};